jQuery(document).ready(function () {
  setTimeout(function () {
    // if ($('.top-hero')) {
    //   $('.top-hero').addClass('is-active');
    // }
  }, 500);
});